// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"271":"4e2c79d068213ac3","920":"a0f0d9ae540cef22"}[chunkId] + ".css";
};